import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";
import { BorderData } from "../../../../Data/UiKits/Tabs";

const BorderTabContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {BorderData &&
        BorderData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default BorderTabContent;
